import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

const cryptoFeatures = [
  {
    icon: 'ri-coins-line',
    color: 'text-orange-400',
    bg: 'bg-orange-400/10',
    title: 'Pagos con Bitcoin',
    description: 'Realiza pagos seguros con Bitcoin. Transacciones rapidas, sin intermediarios bancarios y con comisiones reducidas.'
  },
  {
    icon: 'ri-currency-line',
    color: 'text-blue-400',
    bg: 'bg-blue-400/10',
    title: 'Ethereum & Stablecoins',
    description: 'Aceptamos ETH, USDC y USDT. Precios estables y predecibles para que no te preocupes por la volatilidad.'
  },
  {
    icon: 'ri-shield-check-line',
    color: 'text-emerald-400',
    bg: 'bg-emerald-400/10',
    title: 'Seguridad Blockchain',
    description: 'Todas las transacciones se registran en blockchain. Transparencia total y proteccion contra fraudes.'
  },
  {
    icon: 'ri-coins-line',
    color: 'text-yellow-400',
    bg: 'bg-yellow-400/10',
    title: 'Token POK',
    description: 'Gana tokens POK por cada reserva. Canjealos por descuentos, acceso VIP o reservas gratuitas.'
  },
  {
    icon: 'ri-wallet-3-line',
    color: 'text-purple-400',
    bg: 'bg-purple-400/10',
    title: 'Wallet Integrada',
    description: 'Conecta tu wallet favorita (MetaMask, Trust Wallet, etc.) directamente desde la plataforma.'
  },
  {
    icon: 'ri-exchange-dollar-line',
    color: 'text-green-400',
    bg: 'bg-green-400/10',
    title: 'Cashback Crypto',
    description: 'Recibe hasta un 5% de cashback en criptomonedas por cada reserva que hagas en la plataforma.'
  }
];

const aiFeatures = [
  {
    icon: 'ri-chat-voice-line',
    title: 'Asistente de Voz',
    description: 'Habla con nuestro asistente de IA como si fuera una persona real. Solo di lo que necesitas y el lo hace por ti.'
  },
  {
    icon: 'ri-search-line',
    title: 'Busqueda Inteligente',
    description: 'El asistente encuentra la cancha perfecta segun tu ubicacion, presupuesto, tipo de futbol y disponibilidad.'
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Reservas Automaticas',
    description: 'No necesitas llenar formularios. El asistente reserva la cancha por ti en segundos con tu confirmacion.'
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Comparador de Precios',
    description: 'Compara precios entre canchas cercanas en tiempo real. El asistente te muestra las mejores opciones.'
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Recomendaciones Locales',
    description: 'Recibe recomendaciones personalizadas basadas en tus reservas anteriores y preferencias de juego.'
  },
  {
    icon: 'ri-time-line',
    title: 'Disponible 24/7',
    description: 'El asistente nunca duerme. Reserva canchas a cualquier hora del dia o de la noche, incluso los fines de semana.'
  }
];

const faqs = [
  {
    question: 'Como funciona el pago con criptomonedas?',
    answer: 'Conecta tu wallet (MetaMask, Trust Wallet, etc.), selecciona la cancha que quieres reservar y elige la opcion de pago con crypto. El sistema genera una transaccion segura en blockchain y una vez confirmada, tu reserva queda activa.'
  },
  {
    question: 'Que criptomonedas aceptan?',
    answer: 'Actualmente aceptamos Bitcoin (BTC), Ethereum (ETH), USDC y USDT. Pronto agregaremos mas opciones segun las necesidades de nuestra comunidad.'
  },
  {
    question: 'El asistente de IA puede hacer reservas por mi?',
    answer: 'Si! El asistente puede buscar canchas, comparar precios, verificar disponibilidad y realizar la reserva completa. Solo necesitas confirmar la transaccion final.'
  },
  {
    question: 'Es seguro pagar con criptomonedas?',
    answer: 'Absolutamente. Utilizamos contratos inteligentes auditados y todas las transacciones se registran en blockchain. Ademas, tu dinero esta protegido hasta que confirmes que recibiste el servicio.'
  },
  {
    question: 'Como gano tokens POK?',
    answer: 'Ganas tokens POK automaticamente por cada reserva que realices, por referir amigos y por participar en eventos especiales de la comunidad. Cuanto mas usas la plataforma, mas ganas.'
  },
  {
    question: 'Puedo usar pesos mexicanos todavia?',
    answer: 'Por supuesto. Seguimos aceptando pagos tradicionales con tarjeta de credito, debito y transferencia bancaria. Las criptomonedas son una opcion adicional, no un reemplazo.'
  }
];

export default function CryptoAI() {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const openAssistant = () => {
    const btn = document.querySelector('#vapi-widget-floating-button');
    if (btn) (btn as HTMLElement).click();
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero */}
      <section className="relative bg-gradient-to-br from-green-900 to-green-800 text-white py-20 md:py-28">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[url('https://readdy.ai/api/search-image?query=Abstract%20blockchain%20network%20pattern%20with%20glowing%20green%20nodes%20and%20connections%20on%20dark%20background%2C%20futuristic%20digital%20grid%20representing%20cryptocurrency%20and%20AI%20technology%2C%20subtle%20soccer%20ball%20elements%20integrated%20in%20the%20design%2C%20dark%20minimal%20geometric%20pattern&width=1600&height=900&seq=crypto-ai-bg&orientation=landscape')] bg-cover bg-center"></div>
        </div>
        <div className="container mx-auto px-4 relative">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-white/10 rounded-full px-4 py-2 mb-6">
              <i className="ri-robot-2-line text-emerald-300"></i>
              <span className="text-sm font-medium text-emerald-100">Futuro de las Reservas Deportivas</span>
            </div>
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Criptomonedas + Inteligencia Artificial
            </h1>
            <p className="text-xl md:text-2xl text-green-100 mb-10 leading-relaxed">
              La primera plataforma en Mexico que combina pagos descentralizados 
              con un asistente de IA que revoluciona la forma de reservar canchas.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                size="lg"
                className="bg-white text-green-800 hover:bg-gray-100"
                onClick={() => navigate('/anuncio')}
              >
                <i className="ri-coins-line mr-2"></i>
                Reservar con Crypto
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="border-white text-white hover:bg-white hover:text-green-800"
                onClick={openAssistant}
              >
                <i className="ri-chat-voice-line mr-2"></i>
                Probar Asistente IA
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Crypto Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Pagos con Criptomonedas
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Olvidate de los bancos. Reserva tu cancha con Bitcoin, Ethereum 
              o stablecoins de forma rapida, segura y sin intermediarios.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {cryptoFeatures.map((feature, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300"
              >
                <div className={`w-14 h-14 rounded-lg ${feature.bg} flex items-center justify-center mb-4`}>
                  <i className={`${feature.icon} text-2xl ${feature.color}`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* AI Section */}
      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Asistente de Inteligencia Artificial
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Tu companero virtual para reservar canchas. Habla con el, preguntale, 
              dejalo buscar por ti. La reserva de canchas nunca fue tan facil.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {aiFeatures.map((feature, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl p-6 hover:shadow-lg transition-shadow duration-300"
                >
                  <div className="w-12 h-12 rounded-lg bg-green-100 flex items-center justify-center mb-4">
                    <i className={`${feature.icon} text-xl text-green-600`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">{feature.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
                </div>
              ))}
            </div>
            <div className="relative">
              <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
                <div className="flex items-center gap-3 mb-4 pb-4 border-b border-gray-100">
                  <div className="w-10 h-10 rounded-full bg-green-600 flex items-center justify-center">
                    <i className="ri-robot-2-line text-white"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800">Asistente PokTaPok</p>
                    <div className="flex items-center gap-1">
                      <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                      <span className="text-xs text-green-600">En linea</span>
                    </div>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center shrink-0 mt-1">
                      <i className="ri-user-line text-sm text-gray-500"></i>
                    </div>
                    <div className="bg-gray-100 rounded-xl rounded-tl-sm px-4 py-3 max-w-[80%]">
                      <p className="text-gray-700 text-sm">Hola, necesito una cancha de futbol 7 para el sabado en la tarde en Ciudad de Mexico. Presupuesto de 300 pesos.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 justify-end">
                    <div className="bg-green-600 rounded-xl rounded-tr-sm px-4 py-3 max-w-[80%]">
                      <p className="text-white text-sm">
                        Encontre 3 canchas disponibles para el sabado por la tarde dentro de tu presupuesto:
                      </p>
                      <div className="mt-2 space-y-2">
                        <div className="bg-white/10 rounded-lg p-2 text-white text-xs">
                          <strong>Cancha San Rafael</strong> - Roma Norte - $280/hora
                        </div>
                        <div className="bg-white/10 rounded-lg p-2 text-white text-xs">
                          <strong>Deportivo Centro</strong> - Condesa - $290/hora
                        </div>
                        <div className="bg-white/10 rounded-lg p-2 text-white text-xs">
                          <strong>Cancha Elite</strong> - Polanco - $300/hora
                        </div>
                      </div>
                      <p className="text-white text-sm mt-2">
                        Cual prefieres? Puedo reservarla por ti.
                      </p>
                    </div>
                    <div className="w-8 h-8 rounded-full bg-green-600 flex items-center justify-center shrink-0 mt-1">
                      <i className="ri-robot-2-line text-sm text-white"></i>
                    </div>
                  </div>
                </div>
                <div className="mt-4 pt-4 border-t border-gray-100">
                  <div className="flex items-center gap-2 bg-gray-50 rounded-lg px-4 py-3">
                    <i className="ri-mic-line text-gray-400"></i>
                    <span className="text-sm text-gray-400 flex-1">Escribe o habla...</span>
                    <i className="ri-send-plane-line text-green-600"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-green-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Listo para el futuro?
          </h2>
          <p className="text-green-100 text-lg max-w-2xl mx-auto mb-10">
            Prueba ahora nuestro asistente de IA. Solo haz clic en el boton flotante 
            o usa el boton de abajo para empezar a conversar.
          </p>
          <Button
            size="lg"
            className="bg-white text-green-800 hover:bg-gray-100"
            onClick={openAssistant}
          >
            <i className="ri-chat-voice-line mr-2"></i>
            Hablar con el Asistente
          </Button>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Preguntas Frecuentes
            </h2>
            <p className="text-gray-600 text-lg">
              Todo lo que necesitas saber sobre criptomonedas y nuestro asistente de IA
            </p>
          </div>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="border border-gray-200 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors"
                >
                  <span className="font-semibold text-gray-800 pr-4">{faq.question}</span>
                  <i
                    className={`ri-arrow-down-s-line text-xl text-gray-500 transition-transform shrink-0 ${
                      openFaq === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                {openFaq === index && (
                  <div className="px-6 pb-6">
                    <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}